// LEAVING THIS STORE HERE IN CASE WE NEED IT LATER
// BUT I ACTUALLY THOUGHT OF A BETTER WAY TO HANDLE
// THIS USE CASE. See main layout component for details.

export type RenderState = {
    leftSidebarVisible?: boolean;

    showLeftSidebar: () => void;
    hideLeftSidebar: () => void;

    clear: () => void;
};

export const renderStore = (
    set: (state: RenderState) => void,
    get: () => RenderState,
): RenderState => ({
    leftSidebarVisible: true,

    showLeftSidebar: () => {
        set({
            ...get(),
            leftSidebarVisible: true,
        });
    },
    hideLeftSidebar: () => {
        set({
            ...get(),
            leftSidebarVisible: false,
        });
    },

    clear: () => {
        set({
            leftSidebarVisible: undefined,
            showLeftSidebar: () => {},
            hideLeftSidebar: () => {},
            clear: () => {},
        });
    },
});
